<template>
  <v-div
    class="CommentReply"
    relative
    border-softened-right-thin
    border-softened-left-thin
    border-softened-bottom-thin
  >
    <v-div>
      <v-div pt-6 pl-8 overflow-hidden background-subdued>
        <h4 :id="`comment-header-${comment.id}`">
          <span class="d-sr-only">Response,</span>
          <v-div clear-fix py-3>
            <v-div v-if="!isRemoved" ml-4>
              <v-div subtitle-1 font-weight-bold>
                {{ comment.author | displayName }}
                <span class="d-sr-only">:</span>
              </v-div>
            </v-div>
            <v-div ml-4>
              <v-div font-weight-regular>{{
                comment.createdAt | localDateTime
              }}</v-div>
            </v-div>
          </v-div>
        </h4>
        <v-div v-if="isRemoved" ml-4 mb-2
          >This comment has been removed by the moderator.</v-div
        >
      </v-div>
      <v-card-text v-if="!isRemoved" pt-6 pl-8 overflow-hidden>
        <p>{{ comment.content }}</p>
        <v-div v-if="allowReporting && articleDetailsAllowReporting">
          <v-div v-if="isLoggedIn">
            <v-btn
              :id="`report-${comment.id}`"
              data-test-id="reportReplyButton"
              small
              outlined
              rounded
              :aria-labelledby="`report-${comment.id} comment-header-${comment.id}`"
              @click="reportLoggedIn"
            >
              <span v-if="displayIsDesktop">Report</span>
              <v-icon v-else color="muted">{{ mdiFlag }}</v-icon>
            </v-btn>
          </v-div>

          <VueRecaptcha
            v-else
            ref="replyRecaptcha"
            :sitekey="recaptchaSiteKey"
            size="invisible"
            badge="right"
            @verify="onVerify"
            @expired="onExpired"
          >
            <v-btn
              :id="`report-${comment.id}`"
              data-test-id="reportReplyButton"
              small
              outlined
              rounded
              :aria-labelledby="`report-${comment.id} comment-header-${comment.id}`"
              @click="reportRequested"
            >
              <span v-if="displayIsDesktop">Report</span>
              <v-icon v-else color="muted">{{ mdiFlag }}</v-icon>
            </v-btn>
          </VueRecaptcha>
        </v-div>
      </v-card-text>
    </v-div>
  </v-div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { mdiFlag } from "@mdi/js";
import mapFlags from "~/plugins/utilities/mapFlags";

import { displayIsDesktop } from "~/components/utilities/displayBreakpoints";
import isLoggedIn from "~/plugins/utilities/isLoggedIn";
import commentReport from "~/actions/tasks/commentReport";

export default {
  name: "CommentReply",
  components: {
    VueRecaptcha,
  },
  props: {
    comment: { type: Object, required: true },
    allowReporting: { type: Boolean, default: true },
    recaptchaSiteKey: { type: String, required: false, default: "" },
    showRemovedDetails: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: true,
      // Icon
      mdiFlag,
    };
  },

  computed: {
    displayIsDesktop,
    ...mapState({
      commentReportReasons: (state) =>
        state.referenceData.commentReportReasonTypes,
      user: (state) => state.user,
    }),
    ...mapFlags(["articleDetailsAllowReporting"]),
    isLoggedIn() {
      return isLoggedIn(this.user);
    },
    isRemoved() {
      return this.comment.status === "REMOVED" && !this.showRemovedDetails;
    },
  },
  methods: {
    commentReport,
    reportRequested() {
      this.$refs.recaptcha.execute();
    },
    onVerify(response) {
      this.report(response);
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    reportLoggedIn() {
      this.report(null);
    },
    report(captchaResponse) {
      this.$root.$emit("show-report", {
        title: "Report Comment",
        reportContent: this.comment.content,
        reportContentId: this.comment.id,
        text: "Please let us know how you think this comment contravenes our Commenting and Discussion Policy:",
        options: this.commentReportReasons,
        action: this.commentReport,
        captchaResponse,
      });

      this.$refs.replyRecaptcha?.reset();
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  visibility: hidden;
}
</style>
